import React, { useContext } from 'react';
import Context from "../context/context";
import classnames from 'classnames';

import { Swiper, SwiperSlide } from 'swiper/react';
import { Keyboard, Scrollbar, Navigation, Pagination } from 'swiper/modules';



const TopFilter = props => {
  const {language, topFilter, dragStyle, activeFilters, setActiveFilters} = useContext(Context);

  const data = topFilter;


  if (typeof data.options != "undefined" && topFilter.options.length > 1){

    let options = data.options.filter((option) => {
      return option.value !== "all"
    });


    let total_options = options.length;

    let win_width = window.innerWidth;

    let dir = "vertical";
    if (win_width >= 1024){
      dir = "horizontal";
    }



    const handleClick = (value) => {
      const filter = {...activeFilters["top_filter"]};
      filter.value = value;
      setActiveFilters({...activeFilters,
        ["top_filter"]: filter
      });
    }

    return (
      <>
      <div
        style={dragStyle}
        id="extra_filters"
        className={classnames('top-filter col-' + total_options, {
          open: data.open
        })}
      >
      <div className="top-filter-inner">

        <div className="top-filters-label">{language.top_filter_title}</div>

        <div className="top-filter-items">


        {options.map((option, i) =>


            <div
              className={classnames('top-filter-item ', {
                active: activeFilters["top_filter"].value == option.value
              })}

              onClick={() => handleClick(option.value)}
            >
              {option.name}
            </div>
        )}

        <div
          className={classnames('top-filter-item all ', {
            active: activeFilters["top_filter"].value == data.options[0].value
          })}
          onClick={() => handleClick(data.options[0].value)}
         >
          {data.options[0].name}
        </div>

        </div>

        </div>
        </div>
      </>
    )
  } else {
    return (
      <></>
    )
  }


}

export default TopFilter;
